import PaymentsTip from './PaymentsTip';

export default PaymentsTip;
